import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import moment from "moment";

import List from "../../../../components/Users/Orders/List";

import Api from "../../../../lib/componentApi";

import { GlobalContext } from "../../../../context/GlobalContext";

const OrdersList = ({ orderDetail }) => {
  const [pastOrders, setPastOrders] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const context = useContext(GlobalContext);
  const user = context.user || {};
  useEffect(() => {
    const limit = 10;
    const index = 0;
    Api.post("/api/orders", { limit, index }, (response, errors) => {
      if (errors) {
        console.log(errors);
      } else if (response.code) {
        console.log(response, "code");
      } else {
        setPastOrders(response.pastOrders);
        setRecentOrders(response.recentOrders);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (pastOrders.length || recentOrders.length) {
      const order = recentOrders.length
        ? recentOrders[0]
        : pastOrders.length
        ? pastOrders[0]
        : {};
      const activeStatus = [
        "PAYMENT_SUCCESSFUL",
        "ORDER_PREPARING",
        "ORDER_PREPARED",
        "ORDER_ACCEPTED",
        "ORDER_ACCEPTED_WITH_ADDITIONAL_TIME_USER_CONFIRM_EXPECTED",
        "ORDER_ACCEPTED_WITH_ADDITIONAL_TIME_RESTAURANT_CONFIRM_EXPECTED",
        "ORDER_IN_DRIVER"
      ];

      if (
        (activeStatus.includes(order.status) ||
          (order.status === "ORDER_COMPLETED" &&
            moment(order.orderCompletedDate)
              .add(2, "hours")
              .isBefore(moment(new Date())))) &&
        (user || {}).uid
      ) {
        const intercomSettings = {
          app_id: "hqblgstm",
          name: `${user.firstName} ${user.lastName}`,
          email: user.email
        };
        window.Intercom("boot", intercomSettings);
      }
    }
  }, [pastOrders.length, recentOrders.length]);
  return (
    <React.Fragment>
      <Helmet>
        <title>Orders</title>
        <meta property="og:title" content="Orders" />
      </Helmet>

      <List
        pastOrders={pastOrders}
        recentOrders={recentOrders}
        loading={loading}
        orderDetail={orderDetail}
      />
    </React.Fragment>
  );
};

export default withRouter(OrdersList);
